import {
  Dashboard,
  FolderOpen,
  ViewKanban,
  People,
  Assessment,
  EventBusy,
} from '@mui/icons-material'

export interface MenuItem {
  label: string
  iconName: string // Use string instead of React.ReactNode
  path: string
  roles: string[]
  badge?: number | null
  children?: MenuItem[]
  external?: boolean
  divider?: boolean
}

export interface MenuSection {
  title: string
  items: MenuItem[]
  roles: string[]
  divider?: boolean
}

// Icon mapping object
export const ICON_MAP: Record<string, React.ComponentType<any>> = {
  Dashboard, FolderOpen, ViewKanban, People, Assessment, EventBusy,
}

export const menuConfig: MenuSection[] = [
  {
    title: 'Main Navigation',
    items: [
      {
        label: 'Dashboard',
        iconName: 'Dashboard',
        path: '/dashboard',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
      {
        label: 'Projects',
        iconName: 'FolderOpen',
        path: '/projects',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
    ],
    roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
  },
  {
            title: 'SAR Vexa Management',
    items: [
      {
                                     label: 'Kanban Board',
        iconName: 'ViewKanban',
        path: '/kanban',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
      {
        label: 'My Board',
        iconName: 'ViewKanban',
        path: '/my-board',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
      {
        label: 'Reports',
        iconName: 'Assessment',
        path: '/reports',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
      {
        label: 'Leaves',
        iconName: 'EventBusy',
        path: '/leaves',
        roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
      },
    ],
    roles: ['admin', 'manager', 'developer', 'tester', 'viewer'],
  },
  {
    title: 'Administration',
    items: [
      {
        label: 'User Management',
        iconName: 'People',
        path: '/admin/users',
        roles: ['admin'],
      },
    ],
    roles: ['admin'],
    divider: true,
  },
]

// Helper function to get menu items for a specific role
export const getMenuItemsForRole = (role: string): MenuItem[] => {
  const allItems: MenuItem[] = []
  
  menuConfig.forEach(section => {
    if (section.roles.includes(role)) {
      section.items.forEach(item => {
        if (item.roles.includes(role)) {
          allItems.push(item)
        }
      })
    }
  })
  
  return allItems
}

// Helper function to get menu sections for a specific role
export const getMenuSectionsForRole = (role: string): MenuSection[] => {
  return menuConfig.filter(section => section.roles.includes(role))
}

// Helper function to check if user has access to a specific path
export const hasAccessToPath = (path: string, role: string): boolean => {
  for (const section of menuConfig) {
    if (section.roles.includes(role)) {
      for (const item of section.items) {
        if (item.path === path && item.roles.includes(role)) {
          return true
        }
      }
    }
  }
  return false
}

// Helper function to get icon component by name
export const getIconComponent = (iconName: string): React.ComponentType<any> => {
  return ICON_MAP[iconName] || Dashboard // Default to Dashboard if icon not found
}
